import Link from 'next/link';
import { AppImage } from '@workspace/ui/common';
import { sanityImageSrc } from '@/sanity/lib/image';
import { SanityImage } from '@workspace/interfaces';
import { LinkTarget } from '@workspace/ui/common';

interface ContactSupportImageProps {
  image?: SanityImage;
  imageAlt?: string;
  imageHref?: string;
  imageTarget?: LinkTarget;
}

export function ContactSupportImage({
  image,
  imageAlt = 'Contact support image',
  imageHref,
  imageTarget = '_self',
}: ContactSupportImageProps) {
  if (!image?.asset?._ref && !image?.url) return null;

  const altText = image?.alt || imageAlt;

  const imageElement = (
    <div className="relative md:h-135.5 w-full md:w-101.5 overflow-hidden">
      <AppImage
        src={sanityImageSrc(image, { width: 406, height: 542 })}
        alt={altText}
        fill
        className="object-cover"
        sanityImage={image}
      />
    </div>
  );

  return (
    <div className="order-1 md:order-0 hidden md:block">
      {imageHref ? (
        <Link
          href={imageHref}
          target={imageTarget}
          rel={imageTarget === '_blank' ? 'noopener noreferrer' : undefined}
          className="block"
        >
          {imageElement}
        </Link>
      ) : (
        imageElement
      )}
    </div>
  );
}
